"use strict";

var cov_1u2jo2v4qf = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/tree-blob/TreeObject.js";
  var hash = "3768ee67311c6f62ae25d2f21aedc75fd914109b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/tree-blob/TreeObject.js",
    statementMap: {
      "0": {
        start: {
          line: 31,
          column: 20
        },
        end: {
          line: 31,
          column: 51
        }
      },
      "1": {
        start: {
          line: 33,
          column: 15
        },
        end: {
          line: 35,
          column: 18
        }
      },
      "2": {
        start: {
          line: 37,
          column: 2
        },
        end: {
          line: 63,
          column: 4
        }
      },
      "3": {
        start: {
          line: 66,
          column: 0
        },
        end: {
          line: 88,
          column: 2
        }
      },
      "4": {
        start: {
          line: 90,
          column: 0
        },
        end: {
          line: 93,
          column: 2
        }
      },
      "5": {
        start: {
          line: 95,
          column: 15
        },
        end: {
          line: 102,
          column: 2
        }
      },
      "6": {
        start: {
          line: 95,
          column: 25
        },
        end: {
          line: 102,
          column: 1
        }
      },
      "7": {
        start: {
          line: 104,
          column: 26
        },
        end: {
          line: 104,
          column: 65
        }
      }
    },
    fnMap: {
      "0": {
        name: "TreeObjectComponent",
        decl: {
          start: {
            line: 20,
            column: 9
          },
          end: {
            line: 20,
            column: 28
          }
        },
        loc: {
          start: {
            line: 30,
            column: 3
          },
          end: {
            line: 64,
            column: 1
          }
        },
        line: 30
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 95,
            column: 15
          },
          end: {
            line: 95,
            column: 16
          }
        },
        loc: {
          start: {
            line: 95,
            column: 25
          },
          end: {
            line: 102,
            column: 1
          }
        },
        line: 95
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 31,
            column: 30
          },
          end: {
            line: 31,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 30
          },
          end: {
            line: 31,
            column: 38
          }
        }, {
          start: {
            line: 31,
            column: 42
          },
          end: {
            line: 31,
            column: 44
          }
        }],
        line: 31
      },
      "1": {
        loc: {
          start: {
            line: 33,
            column: 15
          },
          end: {
            line: 35,
            column: 18
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 34,
            column: 14
          }
        }, {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 35,
            column: 18
          }
        }],
        line: 33
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "3768ee67311c6f62ae25d2f21aedc75fd914109b"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeObject = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _path = _interopRequireDefault(require("path"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _ = require("./");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * A TreeObject Component to render a Git Tree tree object.
 */


function TreeObjectComponent(_ref) {
  var classes = _ref.classes,
      path = _ref.path,
      tree = _ref.tree,
      url = _ref.url,
      selected = _ref.selected,
      pathSelected = _ref.pathSelected,
      onBlob = _ref.onBlob,
      depth = _ref.depth,
      filepath = _ref.filepath;
  cov_1u2jo2v4qf.f[0]++;

  var _filepath = (cov_1u2jo2v4qf.s[0]++, _path.default.join((cov_1u2jo2v4qf.b[0][0]++, filepath) || (cov_1u2jo2v4qf.b[0][1]++, ''), path));

  var icon = (cov_1u2jo2v4qf.s[1]++, selected ? (cov_1u2jo2v4qf.b[1][0]++, _react.default.createElement(_icons.Folder, null)) : (cov_1u2jo2v4qf.b[1][1]++, _react.default.createElement(_icons.FolderOpen, null)));
  cov_1u2jo2v4qf.s[2]++;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_core.ListItem, {
    button: true,
    selected: selected,
    className: classes.root,
    style: {
      paddingLeft: depth + 'em'
    }
  }, _react.default.createElement(_core.ListItemIcon, {
    style: {
      marginRight: 0
    }
  }, icon), _react.default.createElement(_core.ListItemText, {
    className: classes.pathText,
    primary: path + '/'
  })), _react.default.createElement(_.Tree, {
    pathSelected: pathSelected,
    tree: tree,
    url: url,
    selected: selected,
    onBlob: onBlob,
    depth: depth + 1,
    filepath: _filepath
  }));
}

cov_1u2jo2v4qf.s[3]++;
TreeObjectComponent.propTypes = {
  /** @ignore */
  classes: _propTypes.default.object.isRequired,

  /** The filename or path in the Git Tree Object */
  path: _propTypes.default.string.isRequired,

  /** An array of paths from the Gitea file tree api. */
  tree: _propTypes.default.arrayOf(_propTypes.default.shape({
    path: _propTypes.default.string.isRequired,
    type: _propTypes.default.oneOf(['tree', 'blob']).isRequired
  })),

  /** The Url to fetch the listing if listing is not provided. */
  url: _propTypes.default.string,

  /** Set whether or not the File object is currently selected. */
  selected: _propTypes.default.bool,

  /** Set which of the File object is currently selected. */
  pathSelected: _propTypes.default.string,

  /** Function to propogate when the Blob is selected. */
  onBlob: _propTypes.default.func,

  /** The depth of the path in the tree sets the inset of the component. */
  depth: _propTypes.default.number,

  /** The nested filepath that will concatenate. */
  filepath: _propTypes.default.string
};
cov_1u2jo2v4qf.s[4]++;
TreeObjectComponent.defaultProps = {
  selected: false,
  depth: 1
};
cov_1u2jo2v4qf.s[5]++;

var styles = function styles(theme) {
  cov_1u2jo2v4qf.f[1]++;
  cov_1u2jo2v4qf.s[6]++;
  return {
    root: {
      paddingRight: '0.7em'
    },
    pathText: {
      paddingLeft: '0.7em'
    }
  };
};

var TreeObject = (cov_1u2jo2v4qf.s[7]++, (0, _styles.withStyles)(styles)(TreeObjectComponent));
exports.TreeObject = TreeObject;